import { Twitter, Facebook, Linkedin, Link as LinkIcon, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export default function SocialShare({ url, title }) {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const links = [
    { name: "Twitter", icon: Twitter, href: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}` },
    { name: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}` },
    { name: "LinkedIn", icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}` },
    { name: "WhatsApp", icon: MessageCircle, href: `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}` },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied");
    } catch {
      toast.error("Could not copy");
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid="social-share">
      <span className="kicker text-[color:var(--text-muted)] mr-2 hidden md:block">Share</span>
      {links.map((l) => {
        const Icon = l.icon;
        return (
          <a
            key={l.name}
            href={l.href}
            target="_blank"
            rel="noreferrer"
            className="p-2 border hover:bg-[color:var(--text)] hover:text-[color:var(--bg)] transition-colors"
            style={{ borderColor: "hsl(var(--border-hsl))" }}
            data-testid={`share-${l.name.toLowerCase()}`}
            aria-label={`Share on ${l.name}`}
          >
            <Icon size={16} />
          </a>
        );
      })}
      <button onClick={copy} className="p-2 border hover:bg-[color:var(--text)] hover:text-[color:var(--bg)] transition-colors" style={{ borderColor: "hsl(var(--border-hsl))" }} data-testid="share-copy" aria-label="Copy link">
        <LinkIcon size={16} />
      </button>
    </div>
  );
}
